// Sort orders supported by the Tourpaq search
export const TOURPAQ_SORTING_OPTIONS: Content.Properties.SortingOptions[] = [
  'departureDate',
  'hotelNameAscending',
  'priceAscending',
  'websitePriority',
];

/**
 * Gets the sort order of a campaign search, falling back to website priority
 * when it is not set or not supported by the Tourpaq search
 * @returns {Content.Properties.SortingOptions} The sort order to show and request
 */

export const getCampaignSortBy = ({
  selectedSortBy,
  useTourpaqSearch,
}: Pick<
  Content.Components['SearchSettingsDto'],
  'selectedSortBy' | 'useTourpaqSearch'
>): Content.Properties.SortingOptions => {
  if (useTourpaqSearch && !TOURPAQ_SORTING_OPTIONS.includes(selectedSortBy)) {
    return 'websitePriority';
  }

  return selectedSortBy ?? 'websitePriority';
};
